import React from 'react';

export type UserContextType = {
    route: string;
    user: any;
    jwtToken: string;
    // Resolves to the fresh access token, or null if a new sign-in is required
    refreshToken: () => Promise<string | null>;
    signOut: () => any;
    isAdmin: boolean;
};

export const UserContext = React.createContext<UserContextType>({
    route: '',
    user: {},
    jwtToken: '',
    refreshToken: async () => null,
    signOut: () => {},
    isAdmin: false,
});
